import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import {MainService} from '../../service/main.service';
@Injectable({
  providedIn: 'root'
})
export class UtilityHierService { 

  httpUrl;
  constructor(private http: HttpClient, private main: MainService) { 
    this.httpUrl = this.main.httpUrl;
  }
  async  getOrgHier(obj:any) {
    const resp = await this.http.post<any>(this.httpUrl + '/accounts/orghier/getHier' , obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async  addHier(obj:any) {
    const resp = await this.http.post<any>(this.httpUrl + '/accounts/orghier/addHier' , obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async  updateorgHierstatus(obj:any) {
    const resp = await this.http.put<any>(this.httpUrl + '/accounts/orghier/updateorgHierstatus' , obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async  updateOrgHier(obj:any) {
    const resp = await this.http.put<any>(this.httpUrl + '/accounts/orghier/updateOrgHier' , obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }


  // async  getHierarchy(obj:any) {
  //   const resp = await this.http.post<any>(this.httpUrl + '/accounts/hierarchies/org_hier_xref_levels/getHierarchy' , obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  // async  createHierarchy(obj:any) {
  //   const resp = await this.http.post<any>(this.httpUrl + '/accounts/hierarchies/org_hier_xref_levels/createHierarchy' , obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  // async  updateHierarchy(obj:any) {
  //   const resp = await this.http.put<any>(this.httpUrl + '/accounts/hierarchies/org_hier_xref_levels/updateHierarchy' , obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }

  async  moveOrganizationHierarchy(obj:any){
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/org_hier_xref_levels/moveHierarchy' ,obj).toPromise().then(res => {
      console.log(res)
      return res
    });
    return resp
  }
  // async  deleteHierarchy(obj:any) {
  //   const resp = await this.http.put<any>(this.httpUrl + '/accounts/hierarchies/org_hier_xref_levels/deleteHierarchy', obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }

  //cost center

  async  getCost(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/accounts/costCenter/getCostCenter' , obj).toPromise().then(res => {
      return res
    });
    console.log(resp)
    return resp
  }


  //data assign

  // async getAllAccountdataAssigned(obj:any) {
  //   const resp = await this.http.get<any>(this.main.httpUrl + '/account/setting/accountdataAssign/getAllAccountdataAssigned' + obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  // async insertAccountdataAssign(obj:any) {
  //   const resp = await this.http.post<any>(this.main.httpUrl + '/account/setting/accountdataAssign/insertAccountdataAssign' ,obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }

  // async updateAccountdataAssign(obj:any) {
  //   const resp = await this.http.put<any>(this.main.httpUrl + '/account/setting/accountdataAssign/updateAccountdataAssign' ,obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }

  // async getuseerAssigneddata(obj:any) {
  //   const resp = await this.http.get<any>(this.main.httpUrl + '/account/setting/accountdataAssign/getuseerAssigneddata'+obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  async  getprojectHierarchy(obj :any){
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/project/getHierarchy',obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  createProjectHierarchyOnAccount(obj :any){
    const resp = this.http.post<any>(this.main.httpUrl +'/accounts/hierarchies/project/createHierarchy',obj).toPromise().then(res => {
      return res
    });
    return resp
  } 

  async  projectupdateHierarchy(obj:any ) {
    const resp = this.http.put<any>(this.httpUrl + '/accounts/hierarchies/project/updateHierarchy',obj ).toPromise().then(res => {
      return res
    });
    return resp
  }

  async deleteHierarchy(obj :any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/accounts/hierarchies/project/deleteHierarchy' ,obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

// data assignment 



async getAllgetDataAssigned(obj :any){
  const resp = await this.http.get<any>(this.main.httpUrl + '/metadata/data-assignment/getDataAssigned' + obj).toPromise().then(res => {
    return res;
  });
  return resp;
}
async insertDataAssign(obj :any){
  const resp = await this.http.post<any>(this.main.httpUrl + '/metadata/data-assignment/insertDataAssign' ,obj).toPromise().then(res => {
    return res;
  });
  return resp;
}

async updateDataAssign(obj :any){
  const resp = await this.http.put<any>(this.main.httpUrl + '/metadata/data-assignment/updateDataAssign' ,obj).toPromise().then(res => {
    return res;
  });
  return resp;
}

async getuserAssigneddata(obj :any){
  const resp = await this.http.get<any>(this.main.httpUrl + '/metadata/data-assignment/getuseerAssignedData'+obj).toPromise().then(res => {
    return res;
  });
  return resp;
}

}
